export const ACTIVE_BOOKING = 'You already have an active booking';
